import { EDocMetadata, EDocMetadataProps } from '@/components/EDocMetadata';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import {
  ButtonV2,
  IconClose,
  Popover,
} from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useCallback, useMemo, useState } from 'react';
import styles from './Details.module.scss';

const cx = classNames.bind(styles);

export type Props = EDocMetadataProps;

export const Details: FC<Props> = memo((rest) => {
  const container = useGlobalContainerRef();
  const memorizedContent = useCallback(
    ({ onClose }: { onClose: VoidFunction }) => {
      return <InnerDetails onClose={onClose} {...rest} />;
    },
    [rest]
  );

  const [open, setOpen] = useState(false);
  const onClick = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);
  const onClose = useCallback(() => {
    setOpen(false);
  }, []);
  const memorizedButton = useMemo(() => {
    return (
      <ButtonV2
        containerClassName={cx(styles['black-button'])}
        testId='btn-open'
        onClick={onClick}
      >
        詳細
      </ButtonV2>
    );
  }, [onClick]);

  return (
    <Popover
      open={open}
      onClose={onClose}
      placement='bottomLeft'
      openContent={memorizedButton}
      getPopupContainer={container}
      getTooltipContainer={container}
      content={memorizedContent}
      disableOutSideClick
      overlayClassName={cx(styles['popover-container'])}
    />
  );
});
Details.displayName = 'Details';

type InnerDetailsProps = {
  onClose: VoidFunction;
} & EDocMetadataProps;

const InnerDetails: FC<InnerDetailsProps> = memo(
  ({
    dpi,
    pixelNumber,
    imageDepth,
    type,
    isScan,
    isSatisfyResolutionRequirement,
    isSatisfyDepthRequirements,
    onClose,
  }) => {
    const leftRightRatio = useMemo(
      () => ({
        left: {
          max: '160px',
          min: '160px',
        },
        right: {
          max: '236px',
          min: '236px',
        },
      }),
      []
    );
    return (
      <div className={cx(styles['container'])}>
        <button onClick={onClose} className={cx(styles['icon'])}>
          <IconClose size={18} />
        </button>
        <div className={cx(styles['list'])}>
          <EDocMetadata
            dpi={dpi}
            pixelNumber={pixelNumber}
            imageDepth={imageDepth}
            type={type}
            isScan={isScan}
            isSatisfyResolutionRequirement={isSatisfyResolutionRequirement}
            isSatisfyDepthRequirements={isSatisfyDepthRequirements}
            leftRightRatio={leftRightRatio}
          />
        </div>
      </div>
    );
  }
);
InnerDetails.displayName = 'InnerDetails';
